import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { store } from "../redux";
import {
  messaging,
  onMessageListener,
  requestNotificationPermission,
} from "./firebase";
import { getToken } from "firebase/messaging";
import {
  addNotification,
  setNewNotificationTrue,
} from "../redux/reducers/notifications";
import { updateAiWheel } from "../redux/reducers/aiWheels";
import { useQueryClient } from "react-query";

const NotificationHandler = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  useEffect(() => {
    const initialize = async () => {
      try {
        // Check if messaging is available before proceeding
        if (!messaging) {
          console.log("Firebase messaging not available in this browser");
          return;
        }

        // Request notification permission first
        const permissionToken = await requestNotificationPermission();
        if (permissionToken) {
          console.log("FCM Permission Token received:", permissionToken);
        }

        // Register service worker only if supported
        if ("serviceWorker" in navigator) {
          try {
            const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
            console.log("Service Worker registered with scope:", registration.scope);
            
            // Only get FCM token after service worker is registered and messaging is available
            if (messaging) {
              const fcmToken = await getToken(messaging, {
                vapidKey: "BJKnKWPgogNr6I513LAe6aeAilu4KjHgrYWTlrc4md3euzIuTD8LFGTQDHf8Am6LzLfw9HcINAyKlIGd42hD9i8",
              });
              console.log("FIREBASE == FCM Token:", fcmToken);
            }
          } catch (swError) {
            console.warn("Service Worker registration failed:", swError);
          }
        }
      } catch (error) {
        console.warn("Notification initialization failed (this is normal in some browsers):", error);
      }
    };

    initialize();

    // Handle foreground notifications only if messaging is available
    if (messaging) {
      onMessageListener((payload) => {
        console.log({ payload }, "NOTIFICATION PAYLOAD");
        if (payload.data.type == "15") {
          if (payload.data.status == "SUCCESS") {
            // Invalidate all wheels queries to trigger a refresh
            queryClient.invalidateQueries(["fetchWheels"]);
          }
          dispatch(
            updateAiWheel({
              id: payload.data.ref_id,
              ...payload.data,
            })
          );
        } else if (payload?.notification?.title) {
          store.dispatch(setNewNotificationTrue());
          store.dispatch(addNotification({ 
            id: payload.messageId, 
            ...payload.notification,
            ...payload.data 
          }));
        }
      });
    }

    // Add message listener for background notifications only if service worker is supported
    if ('serviceWorker' in navigator) {
      try {
        navigator.serviceWorker.addEventListener('message', (event) => {
          console.log({event},"BACKGROUND NOTIFICATION")
          if (event.data.type === 'BACKGROUND_NOTIFICATION') {
            if(event.data.payload.data.type=="15"){
              dispatch(updateAiWheel({
                id: event.data.payload.data.ref_id,
                ...event.data.payload.data
              }))
            }
            else if (event.data.payload?.notification?.title) {
              store.dispatch(setNewNotificationTrue());
              store.dispatch(addNotification({ 
                id: event.data.payload.messageId, 
                ...event.data.payload.notification,
                ...event.data.payload.data 
              }));
            }
          }
        });
      } catch (swListenerError) {
        console.warn("Failed to add service worker event listener:", swListenerError);
      }
    }
  }, [dispatch, queryClient]);

  return null;
};

export default NotificationHandler;
